import React from "react";
import Modal from "react-modal";
import { HeaderConfiguration } from "../common";
import CategoryMenuLoginContainer from "./CategoryMenuLoginContainer";

interface CategoyMenuModalProperties {
    readonly parentSelector: HTMLElement;
    readonly headerConfiguration: HeaderConfiguration;
    readonly onClose: () => void;
}

export default function CategoryMenuModal({ parentSelector, headerConfiguration, onClose }: CategoyMenuModalProperties): React.JSX.Element {
    const [isOpen, setIsOpen] = React.useState<boolean>(true);

    const closeModal = (): void => {
        setIsOpen(false);
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            id="#headerContainerCategories"
            className="header-categories-menu-modal"
            portalClassName="header-categories-menu-modal"
            parentSelector={() => parentSelector}
            overlayElement={(_properties, contentElement) => contentElement}
            /* eslint-disable-next-line react/jsx-no-useless-fragment */
            contentElement={(_properties, children) => <>{children}</>}
        >
            <div className="header-categories-menu-modal-left">
                <button type="button" className="close" onClick={closeModal}>
                    <i className="fa-solid fa-times"></i>
                </button>

                <CategoryMenuLoginContainer headerConfiguration={headerConfiguration} />

                {headerConfiguration.categories.map((category) => <a key={category.url} href={category.url}>
                    <div className="col-lg-3 col-sm-4 col-xs-12">
                        <div className="header-categories-menu-modal-item-wrap">
                            <img src={`/css/image/category_${category.cssIndex}.png`} alt={category.title} />
                            <img src={`/css/image/category_${category.cssIndex}_hover.png`} alt={category.title} />
                            <span>{category.title}</span>
                        </div>
                    </div>
                </a>)}

                <div className="col-xs-12 category-separator"></div>

                {headerConfiguration.textPages.map((textPage) => <a key={textPage.url} href={textPage.url} className="mobile-only">
                    <div className="col-lg-3 col-sm-4 col-xs-12">
                        <div className="header-categories-menu-modal-item-wrap">
                            <i className={textPage.icon}></i>
                            <span>{textPage.title}</span>
                        </div>
                    </div>
                </a>)}

            </div>
            <div className="header-categories-menu-modal-right">
            </div>
        </Modal>
    );
}
